import { TranslateLoader } from "@ngx-translate/core";
import { Observable } from "rxjs";

export abstract class TranslationLoader extends TranslateLoader{
  abstract setResources(resources: string[]): void;
  abstract getLoadedKeys(): Observable<string>;
  abstract emitTranslations(): Observable<void>;
}
